import { useEffect, useState } from 'react';
import { NavigateFunction, useLocation, useNavigate } from 'react-router-dom';

import { ITab } from 'coreOld/types';
import { goTo } from 'coreOld/utils';
import {
  manufacturersPath,
  oldPartsPath,
  searchPath,
  sitesPath,
  usersPath,
} from 'system/routes/routePaths';

import SystemSettingsView from './SystemSettingsView';

const tabItems = [
  {
    title: 'Parts',
    onClick: () => goTo(oldPartsPath()),
  },
  {
    title: 'Users',
    path: usersPath(),
  },
  {
    title: 'Manufacturers',
    path: manufacturersPath(),
  },
  {
    title: 'Sites',
    path: sitesPath(),
  },
  {
    title: 'Search',
    path: searchPath(),
  },
];

const getActiveTabByPathname = (pathname: string) => {
  const activeTab = tabItems.find((tab) => tab.path === pathname);

  return activeTab ?? tabItems[1];
};

const navigateToActiveTab = (tab: ITab, navigate: NavigateFunction) => {
  if (tab?.onClick) {
    tab.onClick();

    return;
  }

  navigate(tab.path);
};

const SystemSettings = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [activeTab, setActiveTab] = useState<ITab>(getActiveTabByPathname(location.pathname));

  const onClick = (tab: ITab) => {
    setActiveTab(tab);
    navigateToActiveTab(tab, navigate);
  };

  useEffect(() => {
    if (activeTab) {
      navigateToActiveTab(activeTab, navigate);
    }
  }, [location.pathname]);

  return <SystemSettingsView tabItems={tabItems} onClick={onClick} />;
};

export default SystemSettings;
